export const wizardStatusItems = (instance) => {
  return {
    DRAFT: { key: 'Draf', label: instance.$t('delivery.status.draft') },
    CONFIRMED: { key: 'Dikonfirmasi', label: instance.$t('delivery.status.confirmed') },
    SCHEDULED: { key: 'Dijadwalkan', label: instance.$t('delivery.status.scheduled') },
    RESCHEDULED: { key: 'Dijadwalkan Ulang', label: instance.$t('delivery.status.rescheduled') },
    STARTED: { key: 'Dijalankan', label: instance.$t('delivery.status.started') },
    PICKED: { key: 'Diambil', label: instance.$t('delivery.status.picked') },
    DELIVERED: { key: 'Terkirim', label: instance.$t('delivery.status.delivered') },
    CANCELED: { key: 'Dibatalkan', label: instance.$t('delivery.status.canceled') },
    WAITING_FOR_VENDOR: { key: 'Menunggu Vendor', label: instance.$t('delivery.status.waiting_for_vendor') },
    ACCEPTED_BY_VENDOR: { key: 'Diterima Vendor', label: instance.$t('delivery.status.accepted_by_vendor') },
    REJECTED_BY_VENDOR: { key: 'Ditolak', label: instance.$t('delivery.status.rejected_by_vendor') },
    TRANSITED: { key: 'Sedang Transit', label: instance.$t('delivery.status.inTransit') },
  }
}